import { useAutoneTranslation } from '@autone/translations';
import { forwardRef, type HTMLAttributes } from 'react';

import { cn } from '../../../tailwind';

type SavedFiltersTemplatesContentProps = HTMLAttributes<HTMLDivElement>;

export const SavedFiltersTemplatesContent = forwardRef<
  HTMLDivElement,
  SavedFiltersTemplatesContentProps
>(({ className, children, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'flex flex-col rounded-md shadow-sm bg-white p-5 gap-5',
      className,
    )}
    {...props}
  >
    {children}
  </div>
));

type SavedFiltersTemplatesHeaderProps = HTMLAttributes<HTMLDivElement>;

export const SavedFiltersTemplatesHeader = forwardRef<
  HTMLDivElement,
  SavedFiltersTemplatesHeaderProps
>(({ className, children, ...props }, ref) => {
  return (
    <div
      className={cn('w-full justify-between items-center text-base', className)}
      {...props}
      ref={ref}
    >
      {children}
    </div>
  );
});

type SavedFiltersTemplatesTitleProps = HTMLAttributes<HTMLDivElement>;

export const SavedFiltersTemplatesTitle = forwardRef<
  HTMLDivElement,
  SavedFiltersTemplatesTitleProps
>(({ className, children, ...props }, ref) => (
  <div className={cn('font-semibold', className)} {...props} ref={ref}>
    {children}
  </div>
));

type SavedFiltersTemplatesSummaryBoxProps = HTMLAttributes<HTMLDivElement>;

export const SavedFiltersTemplatesSummaryBox = forwardRef<
  HTMLDivElement,
  SavedFiltersTemplatesSummaryBoxProps
>(({ className, children, ...props }, ref) => {
  const { common } = useAutoneTranslation();
  return (
    <div
      ref={ref}
      className={cn('bg-grey-5 p-3 rounded-md gap-3 flex flex-col', className)}
      {...props}
    >
      <span className="text-base">{common('filters.filter-summary')}</span>
      {children}
    </div>
  );
});

type SavedFiltersTemplatesFooterProps = HTMLAttributes<HTMLDivElement>;

export const SavedFiltersTemplatesFooter = ({
  className,
  children,
  ...props
}: SavedFiltersTemplatesFooterProps) => (
  <div
    className={cn(
      'flex justify-end gap-2 border-t-[1px] border-grey-20 px-5 py-3',
      className,
    )}
    {...props}
  >
    {children}
  </div>
);
